import { Mail } from 'lucide-react';
import Select from 'react-select';
import { FormikProps } from 'formik';
import InputField from 'components/shared/input-field';
import Button from 'components/shared/button';
import { OptionType } from 'types';
import { handleCurrencyInput, LoanCalculatorFormValues } from './utis';

interface LoanCalculatorFormProps {
  formik: FormikProps<LoanCalculatorFormValues>;
  isLoading: boolean;
  options: OptionType[];
  maxAmount?: number;
}

const LoanCalculatorForm = ({
  formik,
  isLoading,
  options,
  maxAmount,
}: LoanCalculatorFormProps) => {
  // utils/handleCurrencyInput.ts

  return (
    <form onSubmit={formik.handleSubmit} className="space-y-4 w-full mt-6">
      <InputField
        type="text"
        name="monthlyIncome"
        placeholder="₦ Enter your predictable monthly income"
        value={formik.values.monthlyIncome}
        onBlur={formik.handleBlur}
        onChange={(e) =>
          handleCurrencyInput(e, formik.setFieldValue, 'monthlyIncome')
        }
        required
        error={formik.errors.monthlyIncome}
      />

      <InputField
        type="text"
        name="loanAmount"
        placeholder="₦ Enter your desired loan amount"
        value={formik.values.loanAmount}
        onChange={(e) =>
          handleCurrencyInput(e, formik.setFieldValue, 'loanAmount', maxAmount)
        }
        onBlur={formik.handleBlur}
        required
        error={formik.errors.loanAmount}
      />

      <div className="w-full mb-4">
        <Select
          id="durationInMonths"
          name="durationInMonths"
          options={options}
          value={
            options.find(
              (option) => option?.value === formik?.values?.durationInMonths
            ) || null
          }
          onChange={(option) => {
            formik.setFieldValue('durationInMonths', option?.value);
          }}
          className="basic-multi-select"
          placeholder="Select your desired repayment duration (in months)"
          classNamePrefix="select"
          styles={{
            control: (provided) => ({
              ...provided,
              borderColor: formik.errors.durationInMonths
                ? 'red'
                : provided.borderColor,
              padding: '4px 0px',
              marginTop: '2px',
              borderRadius: '8px',
            }),
          }}
        />
        {formik.errors.durationInMonths && (
          <p className="text-red-500 text-xs mt-1">
            {formik.errors.durationInMonths}
          </p>
        )}
      </div>
      <InputField
        endIcon={<Mail className="text-BrandPrimary" />}
        type="text"
        name="emailAddress"
        placeholder="Email Address"
        value={formik.values.emailAddress}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        required
        error={formik.errors.emailAddress}
      />

      <Button
        className="w-full"
        type="submit"
        disabled={!formik.isValid || !formik.dirty || isLoading}
      >
        {isLoading ? 'Calculating...' : 'Calculate Loan Offer'}
      </Button>
    </form>
  );
};

export default LoanCalculatorForm;
